<span (click)="onClickConfig(params)" class="btn-label" title="Configurar">
  <i class="fa fa-pencil" role="button" style="color:#444444"></i>
</span>
